import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

var log = require('loglevel').getLogger('core/hoc/prop-wire');

function linkProp(valuePropType) {
  return PropTypes.shape({
    value: valuePropType,
    requestChange: PropTypes.func
  });
}

export function wireSet(Component, propCfg) {
  var _class, _temp;

  propCfg = _.mapValues(propCfg, function (cfg, propName) {
    return _objectSpread({
      linkName: propName + 'Link',
      defaultName: 'default' + _.capitalize(propName),
      changeHandlerName: 'on' + _.capitalize(propName) + 'Change',
      defaultValue: ''
    }, cfg);
  });
  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", _.mapValues(propCfg, function (_ref, propName) {
        var linkName = _ref.linkName,
            defaultName = _ref.defaultName,
            masterDefaultValue = _ref.defaultValue;
        var _this$props = _this.props,
            val = _this$props[propName],
            valueLink = _this$props[linkName],
            defaultValue = _this$props[defaultName];

        if (val == null && valueLink) {
          val = valueLink.value;
        }

        if (val == null) {
          val = defaultValue;
        }

        if (val == null) {
          val = masterDefaultValue;
        }

        return val;
      }));

      _defineProperty(_assertThisInitialized(_this), "handleChange", function (propName, newVal, eventInfo) {
        var isControlled = _.has(_this.props, propName);

        var _propCfg$propName = propCfg[propName],
            linkName = _propCfg$propName.linkName,
            changeHandlerName = _propCfg$propName.changeHandlerName;
        var _this$props2 = _this.props,
            valueLink = _this$props2[linkName],
            handler = _this$props2[changeHandlerName];

        var eventData = _objectSpread({
          before: _this.state[propName]
        }, eventInfo);

        if (isControlled) {
          if (!handler) {
            log.error("handleChange::".concat(Component.displayName, "::").concat(propName, ". Controlled component without a '").concat(changeHandlerName, "' event prop"));
          } else {
            handler(newVal, eventData);
          }
        } else if (valueLink) {
          valueLink.requestChange(newVal, eventData);
        } else {
          _this.setState(_defineProperty({}, propName, newVal), function () {
            if (handler) {
              handler(_this.state[propName], eventData);
            }
          });
        }
      });

      return _this;
    }

    _createClass(_class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        if (!_.isEqual(prevProps, this.props)) {
          var nextState = _.mapValues(propCfg, function (_ref2, propName) {
            var linkName = _ref2.linkName,
                defaultName = _ref2.defaultName;
            var _this2$props = _this2.props,
                val = _this2$props[propName],
                valueLink = _this2$props[linkName];
            var curVal = _this2.state[propName];

            if (val == null && valueLink) {
              val = valueLink.value;
            }

            if (val == null) {
              val = curVal;
            }

            return val;
          });

          this.setState(nextState);
        }
      } // UNSAFE_componentWillReceiveProps(nextProps) {
      //     let nextState = _.mapValues(propCfg, ({linkName, defaultName}, propName) => {
      //         let {[propName]:val, [linkName]:valueLink} = nextProps
      //         let {[propName]:curVal} = this.state
      //         if (val==null && valueLink) {
      //             val = valueLink.value
      //         }
      //         if (val == null) {
      //             val = curVal
      //         }
      //         return val
      //     })
      //     this.setState(nextState)
      // }

    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var propsToIgnore = _(propCfg).map(function (_ref3) {
          var linkName = _ref3.linkName,
              defaultName = _ref3.defaultName;
          return [linkName, defaultName];
        }).flatten().value();

        var propsToAdd = _.reduce(propCfg, function (acc, _ref4, propName) {
          var changeHandlerName = _ref4.changeHandlerName;
          acc[propName] = _this3.state[propName];
          acc[changeHandlerName] = _this3.handleChange.bind(_this3, propName);
          return acc;
        }, {});

        return /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread(_objectSpread({}, _.omit(this.props, propsToIgnore)), propsToAdd), {}, {
          ref: function ref(_ref5) {
            _this3._component = _ref5;
          }
        }));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", _.reduce(propCfg, function (acc, cfg, propName) {
    var linkName = cfg.linkName,
        defaultName = cfg.defaultName,
        changeHandlerName = cfg.changeHandlerName;
    acc[propName] = PropTypes.any;
    acc[defaultName] = PropTypes.any;
    acc[linkName] = linkProp(PropTypes.any);
    acc[changeHandlerName] = PropTypes.func;
    return acc;
  }, {})), _temp;
}
export function wire(Component, propName) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var changeHandlerName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'onChange';
  return wireSet(Component, _defineProperty({}, propName, {
    defaultValue: defaultValue,
    changeHandlerName: changeHandlerName
  }));
}
export function wireValue(Component) {
  return wire(Component, 'value');
}
export function wireChecked(Component) {
  return wire(Component, 'checked', false);
}
export default {
  wireValue: wireValue,
  wireChecked: wireChecked,
  wire: wire
};